import { useUserContext } from '../context/useUserContext';
import { TextColorForColor } from '../utils/colors';

export const useUserColors = () => {
  const { getUserColor } = useUserContext();

  return {
    getColorForUser: getUserColor,
    // Helper to get both or default
    getColors: (name: string) => {
      const bg = getUserColor(name);
      const text = TextColorForColor(bg);
      return { bg, text };
    },
  };
};
